/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceAssignmentState } from './resourceAssignmentState';


export interface ResourceAssignmentDetails { 
    vcf_org_id?: string;
    assigned_by?: string;
    assigned_time?: Date;
    assignment_state?: ResourceAssignmentState;
}
export namespace ResourceAssignmentDetails {
}


